import React, { useCallback, useEffect, useRef, useState, useContext } from 'react'
import Axios from '../../../axios-proas';
import FilterListIcon from '@mui/icons-material/FilterList';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import ReplayIcon from '@mui/icons-material/Replay';
import {CTooltip} from '../../UI/CTooltip/CTooltip';
import { CSVLink } from "react-csv";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { useLocation, useNavigate } from 'react-router-dom';
import { TableAction, TableActionLink, TAContainer } from '../../../styles/Table.styled';
import { useTheme } from 'styled-components';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';
import {PrimaryBtnOutlineAction} from '../../../styles/Common'
import UserFormModal from '../../../containers/UserForm/UserForm'
import UpdateRepositoryModal from "../../UI/UpdateRepositoryModal/FileManagerModal";
import { AbilityContext } from '../../../ability/AbilityContext';
import { createContextualCan } from '@casl/react'
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { getNotyfObject } from '../../../shared/utility';

const Can = createContextualCan(AbilityContext.Consumer);

function TableActions(props) {
    const { updateShowFilters, filterState, userType, selectedUsers, entityUid, setConfirmationUserModalShow, setNewUserModal, allBailleurs, listOfRoles, handleReset } = props;
    const [csvData, setCsvData] = useState();
    const csvBtn = useRef();
    const navigate = useNavigate();
    const {t} = useTranslation();
    const theme = useTheme();
    const notyf = getNotyfObject();
    const [shouldDownload, setShouldDownload] = useState(false);
    const showFilters = () => {
        updateShowFilters(!filterState)
    }
    const [updateRepositoryShow, setUpdateRepositoryShow] = useState(false);
    const csvHeaders = [
        {label: 'Prénom', key: 'first_name'},
        { label: 'Nom', key: 'last_name' },
        { label: 'Identifiant', key: 'userName' },
        {label: 'Courriel', key: 'email'},
        { label: 'Téléphone', key: 'phoneNumber'},
        {label: 'Active', key: 'active'},
        { label: 'Nom bailleur', key: 'bailleur'},
        {label: 'Rôles', key: 'role'},
        
    ]
    const ability = useContext(AbilityContext);
    
    useEffect(() => {
        if (shouldDownload && csvData && csvBtn.current) {
            csvBtn.current.link.click();
            setShouldDownload(false); // réinitialiser
        }
    }, [shouldDownload, csvData]);

    //const exportSelectionExcel = useCallback(() => {
    //    const getLevelName = (level) => {
    //        let temp = level?.map((item) => {
    //            return listOfRoles?.filter((temp) => temp?.roleId == item?.roleId)[0]?.libelle;
    //        });
    //        return temp.join(", ") || "";
    //    };

    //    const selectedIds = [];
    //    for (const key in selectedUsers)
    //        if (selectedUsers[key]) selectedIds.push(selectedUsers[key]);

    //    Axios.get(
    //        import.meta.env.VITE_PREFIX_SERVER_IDENTITY + "CreateUsers/csvCompressedDocument",
    //        { params: { selection: selectedIds.join() } }
    //    )
    //        .then((response) => {
    //            if (response?.data && allBailleurs) {
    //                let excelData = response?.data?.map((row) => {
    //                    return {
    //                        Prénom: row.first_name, // ⚠️ vérifier que la propriété existe dans ton backend
    //                        Nom: row.userName,
    //                        Courriel: row.email,
    //                        Téléphone: row.phoneNumber,
    //                        Active: row?.lockoutEnd ? "Oui" : "Non",
    //                        "Nom bailleur": allBailleurs.find(
    //                            (temp) =>
    //                                temp.id ==
    //                                row.claims?.filter((item) => item.claimType == "bailleur_id")[0].claimValue
    //                        )?.raisonSociale,
    //                        Rôles: getLevelName(row?.roles),
    //                    };
    //                });

    //                // Création de la feuille Excel
    //                const worksheet = XLSX.utils.json_to_sheet(excelData);
    //                const workbook = XLSX.utils.book_new();
    //                XLSX.utils.book_append_sheet(workbook, worksheet, "Utilisateurs");

    //                // Export direct en .xlsx
    //                XLSX.writeFile(workbook, formattedfileName() + ".xlsx");
    //            }
    //        })
    //        .catch((err) => console.log("Une erreur s'est produite"));
    //}, [selectedUsers, listOfRoles, allBailleurs]);

    const exportSelectionCsv = useCallback(() => {
        const getLevelName = (level) => {
            let temp = level?.map((item, index) => {
                return listOfRoles?.filter((temp) => temp?.roleId == item?.roleId)[0]?.libelle;
            })
            return temp.join(', ') || "";
        }
        const selectedIds = [];
        for (const key in selectedUsers)
            if (selectedUsers[key])
                selectedIds.push(selectedUsers[key])
        Axios.post(import.meta.env.VITE_PREFIX_SERVER_IDENTITY + 'CreateUsers/csvCompressedDocument',  selectedIds )
            .then((response) => {
                if (response?.data && allBailleurs) {
                    let csvDataTemp = response?.data?.map(row => {
                        const bailleurClaim = row?.claims?.filter(c => c.claimType === "bailleur_id")[0];                       
                        const bailleurObj = allBailleurs.filter(b => b.id == bailleurClaim?.claimValue)[0];
                        let lastName = row?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]?.claimValue?.split(".")[1] || "";
                        let firstName =  row?.claims?.filter(claim => claim?.claimType == "urn:younov:displayname")[0]?.claimValue?.split(".")[0] || ""

                        return {
                            email: row.email,
                            last_name: lastName,
                            first_name: firstName,
                            userName: row.userName,
                            phoneNumber: row.phoneNumber,
                            bailleur: bailleurObj?.raisonSociale,
                            role: getLevelName(row?.roles),
                            active: row?.lockoutEnd ? "Oui" : "Non"
                        }
                    })
                    setCsvData(csvDataTemp);
                    setShouldDownload(true); 
                    notyf.success("Export CSV réussi")
                    //csvBtn.current.link.click();
                }
            }).catch(err => {
             
                notyf.error("Une erreur s'est produite lors de l'export")

            })
       

    }, [selectedUsers, listOfRoles, allBailleurs])

    const showCsvExport = () => {
        for (const key in selectedUsers) {
            if (selectedUsers[key])
                return true
        }
        return false
    } 
    const addNewElement = () => {
        setNewUserModal(true)
        setConfirmationUserModalShow(true);

    }

    const updateRepository = () => {
        setUpdateRepositoryShow(true);
    };
   
    const formattedfileName = () => {
        const now = new Date();
        const formattedDate =
            `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}T` +
            `${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;

        const fileName = `Utilisateurs_${formattedDate}.csv`;
        return fileName
    } 
    return (
        <TAContainer>
            {/*<CTooltip title={"Réinitialiser les filtres"}>*/}
            {/*    <PrimaryBtnOutlineAction*/}
            {/*        bg={theme.colors.primary}*/}
            {/*        active={filterState}*/}
            {/*        //onClick={() => showFilters()}                */}
            {/*        onClick={() => handleReset()} >*/}
            {/*        <span>{t('tableAction:filtres',"Filtres" )}</span>*/}
            {/*        <FilterListOffIcon   />*/}
            {/*    </PrimaryBtnOutlineAction>*/}
            {/*</CTooltip>*/}
            {ability.can('add', 'User') &&
            <>
                <PrimaryBtnOutlineAction
                    style={{ backgroundColor: theme.colors.primary }}
                    state={{ entityUid: entityUid }}
                    onClick={(e) => addNewElement()}
                // onClick={(e) => {setConfirmationUserModalShow(true); setNewUserModal(true)}}
                >
                    <span>{t('tableAction:addUser', "Ajouter un utilisateur")}</span>
                    <AddIcon />
                </PrimaryBtnOutlineAction> 
                {userType == "ADMIN_YOUNOV" &&
                    <PrimaryBtnOutlineAction
                        style={{ backgroundColor: theme.colors.primary }}
                        label={"Mettre a jour"} onClick={(e) => updateRepository()}>
                        <span>Importer</span>
                    </PrimaryBtnOutlineAction>
                }
            </>
            }
        
            {
                <PrimaryBtnOutlineAction
                   
                    disabled={!showCsvExport() }
                    style={{ backgroundColor: "#00B050" }}
                    onClick={() => exportSelectionCsv()}>
                    <span>{t("global:exportCsv", "Exporter Csv")}</span>
                    <ImportExportIcon style={{ color: "white" }} />
                </PrimaryBtnOutlineAction>
            }
            {updateRepositoryShow && (
                <UpdateRepositoryModal
                    dataType="users"                
                    show={updateRepositoryShow}
                    handleReset={handleReset}
                    modalClosed={() => setUpdateRepositoryShow(false)}
                />
            )}

            {
                csvData ? (
                    <CSVLink
                        ref={csvBtn}
                        data={csvData}
                        filename={ formattedfileName() }
                        headers={csvHeaders}
                        separator=";" 
                        utf8WithBom={true}
                    >
                    </CSVLink>
            ) : null}
        </TAContainer>
    )
}

const mapStateToProps = (state) => ({
    selectedUsers: state.users.selectedUsers,
    filterState: state.users.showFilters,
    userType: state.auth.userType,
})
const mapDispatchToProps = dispatch => ({
    updateShowFilters: (show) => dispatch(actions.usersUpdateShowFilters(show))
}) 
export default connect(mapStateToProps, mapDispatchToProps) (TableActions)
